import Select from "react-select";
import { useLocale } from 'next-intl'

const SelectiveInput = ({ name, id, addEstate, disabled, options, onChange, value, isHomePage }: any) => {
    const currentLanguage = useLocale();

    if (addEstate && id === 37) {
        options = options.filter((item: any) => item.value !== "83" && item.value !== "84");
    }

    const transformedData = options.map((item: any) => ({
        value: item.value,
        label: item.translations[currentLanguage].name
    }));

    return (
        <div className="mb-3">
            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            <Select
                value={
                    transformedData.filter((option: any) => {
                        return option.value === value;
                    })
                }
                onChange={onChange}
                options={transformedData}
                isDisabled={disabled}
                placeholder={name}
                isClearable
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: '#e8e8e8',
                        fontSize: '14px',
                        color: '#212529',
                        borderRadius: '8px',
                    }),
                }}
            />
        </div>
    )
};
export default SelectiveInput;
